import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { GridRowParams, GridSelectionModel, GridToolbar } from '@mui/x-data-grid-pro';
import { DataTable } from '@pihealth/common-ui-library';
import React, { useEffect } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useAssignToSubjectMutation, useGetAssignedFormsMutation } from 'src/services/subjectToolkit';
import { useGetConfiguredFormsMutation } from 'src/services/toolkitForms';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import staticData from '../../../resources/static.json';
import { setFormLibraryDataIsOpen, setFormLibraryMainData } from 'src/store/SelectedIntrialPatient';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const SubjectToolkit: React.FC<any> = ({ parent_id, prescreen_id }) => {
  // for Datagrdi static columns
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const columns = staticData.subject_Toolkit.colomn;
  const { checkPermission } = usePermissionWrapper();
  const [rows, setRows] = React.useState<any[]>([]);
  // for Tabs
  const [formIds, setFormIds] = React.useState<any>([]);
  const [openConfirmDailog, setOpenConfirmDailog] = React.useState<boolean>(false);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const plannedDate = useAppSelector(state => state.SelectedIntrialPatientInfo.plannedDate);

  const [getAllConfiguredForms, { data: configuredFormsData, isLoading }] = useGetConfiguredFormsMutation();
  const [getAssignedForms, { isLoading: getAssignedFormsIsLoading }] = useGetAssignedFormsMutation();

  const updateData = async (configuredFormsData: any) => {
    const data: any = await getAssignedForms({
      parent_id,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry
    });
    let updated: any = configuredFormsData?.configured_forms?.map((item: any, index: any) => {
      return {
        id: item.id,
        ...item,
        disable: item.required
      };
    });
    let selectedRows = updated?.filter((r: any) => r?.required)?.map((r: any) => r?.id);
    if (data?.data?.assigned_forms?.length) {
      const AssignedForms = data?.data?.assigned_forms;
      selectedRows = selectedRows?.filter((ele: any) => !AssignedForms?.find((val: any) => val?.id === ele));
      updated = updated?.map((ele: any) => {
        const found = AssignedForms?.find((val: any) => val?.id === ele.id);
        if (found) {
          return { ...ele, disable: true };
        } else {
          return ele;
        }
      });
    }
    setRows(updated);
    setSelectionModel(selectedRows);
  };
  useEffect(() => {
    if (configuredFormsData) {
      updateData(configuredFormsData);
    }
  }, [configuredFormsData, parent_id]);

  useEffect(() => {
    getAllConfiguredForms({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      parent_id
    });
  }, [parent_id]);

  const [
    assignTicketToSubject,
    {
      isError: assignTickeToSubjectisError,
      isSuccess: assignTickeToSubjectSuccess,
      isLoading: assignTickeToSubjectLoading,
      error: assignTickeToSubjectError
    }
  ] = useAssignToSubjectMutation();

  useEffect(() => {
    if (!assignTickeToSubjectLoading && assignTickeToSubjectisError) {
      const errorData: any = assignTickeToSubjectError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : URL Not Found`,
            severity: 'error'
          })
        );
      } else {
        dispatch(
          setMessage({
            msgDetails: `Internal Server Error`,
            severity: 'error'
          })
        );
      }
    } else if (!assignTickeToSubjectLoading && assignTickeToSubjectSuccess) {
      const count = formIds.length > 0 ? formIds.length : selectionModel.length;
      dispatch(
        setMessage({
          msgDetails: `${count} form(s) Successfully Assigned`,
          severity: 'success'
        })
      );
      getAllConfiguredForms({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        parent_id
      });
    }
  }, [
    assignTickeToSubjectSuccess,
    assignTickeToSubjectError,
    assignTickeToSubjectLoading,
    assignTickeToSubjectisError
  ]);

  const handleAssignTicket = async () => {
    setOpenConfirmDailog(true);
  };

  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  const dispatch = useAppDispatch();
  // checkbox selection
  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const filteredFormIds: any = rows.filter((row: any) => selectedIds.has(row.id)).map((elem: any) => elem.id);
    setFormIds(filteredFormIds);
  };

  const handleConfirm = async () => {
    let updateReqObject: any;
    if (formIds.count > 0) {
      updateReqObject = {
        form_ids: formIds
      };
    } else {
      updateReqObject = {
        form_ids: selectionModel
      };
    }
    await assignTicketToSubject({
      data: updateReqObject,
      parent_id,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry
    });
    setOpenConfirmDailog(false);
  };

  const handleClose = async () => {
    setOpenConfirmDailog(false);
  };

  const gotoPage = (data: any) => {
    dispatch(setFormLibraryMainData(data));
    dispatch(setFormLibraryDataIsOpen(true));
  };
  const actions = {
    name: (data: any) => {
      gotoPage(data);
    }
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Subject Toolkit ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      {checkPermission('assign_subjecttoolkit') && (
        <Button
          className="btninTabsRight"
          variant="contained"
          disabled={selectionModel.length == 0 || plannedDate == null || getAssignedFormsIsLoading || isLoading}
          onClick={handleAssignTicket}
        >
          Assign to subject
        </Button>
      )}
      <div style={{ minHeight: '50vh', width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataTable
              columns={columns}
              rows={rows}
              components={{
                Toolbar: GridToolbar
              }}
              loading={isLoading || getAssignedFormsIsLoading}
              checkboxSelection
              selectionModel={selectionModel}
              onRowsSelection={onSelectionModelChange}
              disableSelectionOnClick={false}
              pagination
              className="TSDADatagrid"
              isRowSelectable={(params: GridRowParams) => !params.row.disable}
              onSelectionModelChange={onSelectionModelChange}
              exportAll
              customeMessage={'Study Calendar is not activated'}
              actions={actions}
              hasDefinedDataGridToolbarExport
              definedGridToolbarExport={definedCustomDatGridExport}
            />
          </div>
        </div>
      </div>
      <PopupComponent open={openConfirmDailog} onClose={handleClose}>
        <DialogTitle>Send</DialogTitle>
        <DialogContent className="tsda_prescreenDialog">
          <DialogContentText>
            {/* <Alert severity="info">Confirm the forms to be sent to Prescreen ID by listing the selected forms </Alert> */}
            <Typography sx={{ color: 'rgba(0,0,0,0.87)' }}>
              Confirm the forms to be sent to <strong>{prescreen_id}</strong> by listing the selected forms.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirm}>Send</Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};

export default SubjectToolkit;
